import { render, staticRenderFns } from "./Addressbook.vue?vue&type=template&id=f011da16&scoped=true"
import script from "./Addressbook.vue?vue&type=script&lang=js"
export * from "./Addressbook.vue?vue&type=script&lang=js"
import style0 from "./Addressbook.vue?vue&type=style&index=0&id=f011da16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f011da16",
  null
  
)

export default component.exports